// export const url = "http://localhost:4000/api/v1/";
// export const url2 = "http://localhost:4000";

// export const url = "http://192.1688.226.206:4000/api/v1/";
// export const url2 = "http://192.1688.226.206:4000";

export const url = "https://icdc.skyhub.pk/api/v1/";
export const url2 = "https://icdc.skyhub.pk";



export function getDelawareDate() {
    const options = { timeZone: "America/New_York", year: "numeric", month: "2-digit", day: "2-digit" };
    const formatter = new Intl.DateTimeFormat("en-CA", options); // "en-CA" gives the YYYY-MM-DD format
    const parts = formatter.formatToParts(new Date());

    // Extract parts and return formatted date
    const year = parts.find(part => part.type === "year").value;
    const month = parts.find(part => part.type === "month").value;
    const day = parts.find(part => part.type === "day").value;

    return `${year}-${month}-${day}`;
}


export function getLastThreeDigits(id) {
    const parts = id?.split('-');
    return parts[parts?.length - 1];
}